import { joinRequestInitialData } from '../types/InitialData';

export type JoinRequestTableType = {
  inviteID: number
  email: string
  dateReceived: string
  dateAccepted: string
  status: string
}

const convertToJoinRequestReport = (data: joinRequestInitialData): JoinRequestTableType[] => {

  const joinRequests = data?.requests ?? []

  const joinRequestsData = joinRequests.map( joinRequest => ({
    inviteID: joinRequest.inviteID ?? 0,    
    email: joinRequest.email ?? '',    
    dateReceived: joinRequest.dateReceived ?? '',    
    dateAccepted: joinRequest.dateAccepted ?? '',    
    status: joinRequest.status ?? '',    
  }));

  return joinRequestsData;

}

export const JoinRequestTableData = (data: joinRequestInitialData): JoinRequestTableType[] => {
  return convertToJoinRequestReport(data)
}
